import { render, staticRenderFns } from "./dataDownLoad.vue?vue&type=template&id=27c55211&scoped=true&"
import script from "./dataDownLoad.vue?vue&type=script&lang=js&"
export * from "./dataDownLoad.vue?vue&type=script&lang=js&"
import style0 from "./dataDownLoad.vue?vue&type=style&index=0&id=27c55211&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c55211",
  null
  
)

export default component.exports